import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
  & > div {
    cursor: pointer;
  }
`;

const Check = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  padding: 2px 1px 1px 2px;
  border-radius: 0.25rem;
  color: ${(props) => (props.$checked ? 'white' : 'transparent')};
  background: ${(props) => (props.$checked ? '#144896' : 'transparent')};
  border: 2px solid ${(props) => (props.$checked ? '#144896' : '#d8d8d8')};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'default')};
`;

export default function Checkbox({ disabled = false, isChecked, ...props }) {
  return (
    <Wrapper {...props}>
      <Check
        className="d-flex align-items-center justify-content-center lh-1"
        $checked={isChecked}
        $disabled={disabled}
      >
        <FontAwesomeIcon icon={faCheck} fill="currentColor" size="sm" />
      </Check>
    </Wrapper>
  );
}
